<div class="h_loader">
  <svg-icon name="spinner" alt="loader"></svg-icon>
</div>
